(() => {
let $5bb852a376f91c1b$var$helloRetailInitParams = {};
if (Shopify.country) {
    switch(Shopify.country){
        case "US":
            $5bb852a376f91c1b$var$helloRetailInitParams.websiteUuid = "YOUR_US_WEBSITE_UUID";
            break;
        case "DK":
            $5bb852a376f91c1b$var$helloRetailInitParams.websiteUuid = "YOUR_DK_WEBSITE_UUID";
            break;
    }
    /* Ignore if the snippet was inserted without updating the websiteUuid.
  You can skip modifying the UUID if:
    - You only have one country/language storefront in Shopify.
    - Hello Retail only created one configuration for your store.
    - You don’t need locale-specific personalization.
  The fallback/default behavior below ⬇️ will then apply */ if ($5bb852a376f91c1b$var$helloRetailInitParams.websiteUuid && $5bb852a376f91c1b$var$helloRetailInitParams.websiteUuid.startsWith("YOUR_")) delete $5bb852a376f91c1b$var$helloRetailInitParams.websiteUuid;
}
if (Shopify.customerPrivacy) {
    let hr_trackingIsAllowed = Shopify.customerPrivacy.analyticsProcessingAllowed() && Shopify.customerPrivacy.marketingAllowed();
    if (!hr_trackingIsAllowed) $5bb852a376f91c1b$var$helloRetailInitParams.trackingOptOut = true;
}
if (Shopify.currency && Shopify.currency.active && Shopify.currency.rate) {
    let date = new Date();
    date.setTime(date.getTime() + 31536000000);
    let domain = window.location.host;
    if (domain.indexOf("www.") === 0) domain = domain.substring(4);
    document.cookie = "hello_retail_currency=" + encodeURIComponent(JSON.stringify(Shopify.currency)) + "; expires=" + date.toGMTString() + ";domain=." + domain + ";path=/;samesite=lax";
}
window.hrq = window.hrq || [];
hrq.push([
    "init",
    $5bb852a376f91c1b$var$helloRetailInitParams
]);
document.addEventListener("visitorConsentCollected", (event)=>{
    let hr_trackingIsAllowed = Shopify.customerPrivacy.analyticsProcessingAllowed() && Shopify.customerPrivacy.marketingAllowed();
    hrq = window.hrq || [];
    hrq.push(function(sdk) {
        sdk.setTrackingOptOut(!hr_trackingIsAllowed);
    });
});


const $13ea526d8b7b08a2$var$searchInHeaders = document.querySelectorAll('theme-header search-form-header');
const $13ea526d8b7b08a2$var$mainContent = document.querySelector('#main-content');
let $13ea526d8b7b08a2$var$isSearchPageContentLive = false;
let $13ea526d8b7b08a2$var$typingTimeout;
const $13ea526d8b7b08a2$var$searchInHeaderInit = ()=>{
    $13ea526d8b7b08a2$var$searchInHeaders.forEach((searchInHeader)=>{
        const searchInput = searchInHeader.querySelector('input.search-field');
        if (!searchInput) return;
        searchInput.addEventListener('keyup', (e)=>{
            clearTimeout($13ea526d8b7b08a2$var$typingTimeout); // Clear any existing timeout
            $13ea526d8b7b08a2$var$typingTimeout = setTimeout(()=>$13ea526d8b7b08a2$var$searchInputChange(e), 300); // Trigger after 300ms
        });
    });
};
const $13ea526d8b7b08a2$var$searchInputChange = (e)=>{
    const currSearchInput = e.target;
    if (!currSearchInput) return;
    const currValue = currSearchInput.value.trim();
    const currentURL = new URL(window.location.href);
    if (currValue.length > 2) {
        const searchQuery = encodeURIComponent(currValue);
        currSearchInput.addEventListener('blur', (event)=>{
            window.location.href = `/search?q=${searchQuery}`;
        });
        if (currentURL.pathname === '/search') {
            currentURL.searchParams.set('q', searchQuery);
            window.history.replaceState({}, '', currentURL.toString());
            $13ea526d8b7b08a2$var$isSearchPageContentLive = true;
            $13ea526d8b7b08a2$var$renderSearchPageDynamically(searchQuery);
        } else {
            const searchPageURL = `/search?q=${searchQuery}`;
            window.history.pushState({}, '', searchPageURL);
            $13ea526d8b7b08a2$var$renderSearchPageDynamically(searchQuery);
        }
    } else if (currValue.length === 0) window.location.href = '/';
};
const $13ea526d8b7b08a2$var$renderSearchPageDynamically = async (searchQuery, searchPageLive)=>{
    const parser = new DOMParser();
    try {
        const searchPageResponse = await fetch(`/search?q=${searchQuery}`);
        if (!searchPageResponse) return;
        if (searchPageResponse?.status !== 200 && searchPageResponse?.ok !== true) return;
        const contentType = searchPageResponse.headers.get('Content-Type');
        if (contentType.includes('text/html')) {
            const searchPageData = await searchPageResponse.text();
            if (!searchPageData) return;
            const searchPageHtml = parser.parseFromString(searchPageData, "text/html");
            const searchPageMainFullContent = searchPageHtml.querySelector('#main-content');
            const currentMainContent = document.querySelector('#main-content');
            if (!searchPageMainFullContent) return;
            if ($13ea526d8b7b08a2$var$isSearchPageContentLive) {
                if (!currentMainContent) return;
                const currentMainContentSearchContent = currentMainContent.querySelector('.row.search-main-content');
                const searchPageMainRowContent = searchPageMainFullContent.querySelector('.row.search-main-content');
                if (!currentMainContentSearchContent && !searchPageMainFullContent) return;
                const currentMainSearchFound = currentMainContent.querySelector('.template-header--description');
                const searchPageSearchFound = searchPageMainFullContent.querySelector('.template-header--description');
                if (!currentMainSearchFound && !searchPageSearchFound) return;
                currentMainContentSearchContent.innerHTML = searchPageMainRowContent.innerHTML;
                currentMainSearchFound.innerHTML = searchPageSearchFound.innerHTML;
            } else $13ea526d8b7b08a2$var$mainContent.innerHTML = searchPageMainFullContent.innerHTML;
        }
    } catch (err) {
        console.warn("err:", err);
    }
};
const $13ea526d8b7b08a2$var$renderSearchPageContentDynamically = ()=>{};
setTimeout(()=>{
    if ($13ea526d8b7b08a2$var$searchInHeaders && $13ea526d8b7b08a2$var$mainContent) $13ea526d8b7b08a2$var$searchInHeaderInit();
}, 100);



})();
//# sourceMappingURL=parcel_scripts.js.map
